<template>
  <div id="List">
    <!-- banner -->
    <div  class="banner"></div>
    <!-- 导航 -->
    <div class="navList">
      <div class="w1200 clearfix">
        <div class="topDh">
          <!-- 当前位置 -->
          <address-bar :addressBarData="Nav"></address-bar>
        </div>
        <div class="main">
          <div id="infoBox">
            <div v-if="NId" class="newsDetails">
              <template>
                <p class="title">{{ List.Title }}</p>
                <p class="related_information">
                  <span>时间：{{ List.ShowTime }}</span>
                  <span>浏览次数：{{ List.Press }}</span>
                </p>
              </template>
              <div class="info" v-html="List.Details"></div>
            </div>
            <div
              v-else-if="HType == 1 && CId == 5687"
              v-html="List.Info"
              class="singleBox gaikuang"
            ></div>
            <div
              v-else-if="HType == 1"
              v-html="List.Info"
              class="singleBox"
            ></div>
            <component-view
              v-else
              :option="{ dataList: List, componentType: currentValue }"
            ></component-view>
            <page-box
              :pageBoxData="List.PageBar"
              :pageIndex="PageIndex"
            ></page-box>
            <!-- <div class="paging" id="page_turn_box">
                  <a href="">上一页</a>
                  <a href="" class="on">1</a>
                  <a href="">2</a>
                  <a href="">3</a>
                  <a href="">下一页</a>
              </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/list.css";
import addressBar from "@/components/addressBar";
import pageBox from "@/components/pageBox";
import componentView from "../components/componentView";
export default {
  name: "list",
  components: {
    addressBar,
    pageBox,
    componentView
  },
  data() {
    return {
      CId: this.$route.query.CId,
      NId: this.$route.query.NId,
      PageIndex: this.$route.query.PageIndex,
      HType: this.$route.query.HType,
      Nav: "",
      item: "",
      List: [],
      currentData: "",
      currentValue: "pageBox"
    };
  },
  created() {
    this.Nav = this.Curren.SetClassStyle(this.CId);
    this.Nav.List = [];
    this.Nav.lanmu.Fid > 0
      ? (this.Nav.List = this.$root.$children["0"].$children[
          "0"
        ].menuListOne.filter(ele => ele.ID == this.Nav.lanmu.Fid)[0].Children)
      : this.Nav.List.push(this.Nav.lanmu);
    if (this.$root.$children["0"].$children["0"].menuListOne) {
      this.$root.$children["0"].$children["0"].menuListOne.forEach(element => {
        // 确定菜单点击项
        element.ID == this.CId ? (element.On = true) : (element.On = false);
      });
    }
    if (this.NId) {
      //详情
      this.List = this.Base.GetNewsInfoByNid(this.NId);
    } else if (this.HType == 1) {
      //单页
      this.List = this.Base.GetSinglePageInfoByCid(this.CId);
      // console.log(this.List,'单页')
    } else {
      if (this.CId == 5692) {
        //下载
        this.List = this.Base.GetFilesInfoByCid(
          this.CId,
          this.PageIndex,
          "",
          12
        );
        this.currentValue = "downList";
        // console.log(this.List)
      } else if (
        this.CId == 5688 ||
        this.CId == 5689 ||
        this.CId == 5691 ||
        this.CId == 5608 ||
        this.CId == 6359
      ) {
        //无图new-信息公告
        this.List = this.Base.GetNewsInfoByCid(
          this.CId,
          false,
          this.PageIndex,
          "",
          6
        );
        this.currentValue = "noImgList";
      }
      // console.log(this.Nav,'nav');
    }
  }
};
</script>

<style>
#List .banner {
    height: 320px;
    background-image: url(../assets/img/ban-l.png);
    background-size: 100% auto;
}

</style>



// WEBPACK FOOTER //
// src/components/list.vue